import { PopoverMenu, PopoverMenuProps } from '.';
import React from 'react';

// This object should contain a mock value for each required prop of this component
export const requiredProps: PopoverMenuProps = {
  triggerElement: <div />,
};

// This array should contain an object only for tests you wish to run on all compliance tests
const sharedTests = [
  {
    title: 'render',
    props: {
      ...requiredProps,
      children: [<PopoverMenu.MenuItem key="0" />], // TODO this prop should be declared as required since the component explodes without it
    } as PopoverMenuProps,
  },
];

export const testkitTests = [...sharedTests];

export const ssrTests = [...sharedTests];

export const a11yTests = [...sharedTests];
